export const environment = {
  production: false,
  api: {
    serverUrl: 'https://api.dev.blindspotapp.com',
  },
  auth0: {
    domain: 'blindspot-dev.eu.auth0.com',
    clientId: 'yA9eJGO8abnXq9VvT54RplSOSOA2dFGp',
    useRefreshTokens: true,
    cacheLocation: 'localstorage' as const,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://blindspotapp.com/api',
      scope: 'openid profile email offline_access',
    },
  },
  mapbox: {
    accessToken:
      'pk.eyJ1IjoidGlqbHZhbm1pZXJsbyIsImEiOiJjbTg4eGVtNzkwb3hzMmlxdW16cDZwaHZ2In0.oSAquyT3Nfmwpnz0p5055w',
    styleUrl: 'mapbox://styles/tijlvanmierlo/cm88xaoj4008v01s0daovhb62',
  },
  google: {
    clientId:
      '938633502493-3adluuj46hrj25el7dpg47umn1m2dnd9.apps.googleusercontent.com',
  },
  microsoft: {
    clientId: '39bf3076-9fc7-4c48-9563-4ee6b762f5c4',
  },
};
